import { useEffect, useState } from "react";

/**
 * Top-bar streak badge.
 * - Shows current streak when > 0
 * - Animates "grew" celebration when streak_grew is true
 * - "At risk" pulse if streak is alive but user hasn't engaged today yet
 */
export function StreakBadge({ streak, longest, grew, atRisk, onClick }) {
  const [celebrating, setCelebrating] = useState(false);

  useEffect(() => {
    if (grew) {
      setCelebrating(true);
      const t = setTimeout(() => setCelebrating(false), 2200);
      return () => clearTimeout(t);
    }
  }, [grew, streak]);

  if (!streak || streak < 1) return null;

  return (
    <button
      className={`streak-badge ${celebrating ? "celebrating" : ""} ${atRisk ? "at-risk" : ""}`}
      onClick={onClick}
      data-testid="streak-badge"
      title={`${streak} day streak${longest > streak ? ` · longest ${longest}` : ""}`}
      aria-label={`Streak: ${streak} days`}
    >
      <span className="streak-flame" aria-hidden>🔥</span>
      <span className="streak-count">{streak}</span>
    </button>
  );
}
